import type React from 'react';

import { Avatar } from '@change/ds-core-ui/Avatar';
import { Badge } from '@change/ds-core-ui/Badge';
import { DecisionMakerIcon } from '@change/ds-icons/DecisionMakerIcon';

import { useProfileCard } from '../../hooks/useProfileCard';

export const AvatarAndBadge: React.FC<EmptyProps> = () => {
	const {
		data: { photoUrl, displayName, type },
	} = useProfileCard();

	return (
		<div className="pt-6">
			<div className="relative flex justify-center">
				<Avatar
					data-qa="dm-image"
					src={photoUrl}
					alt={`${displayName} profile picture`}
					className="size-[100px] lg:size-[160px]"
				/>
				{type === 'POLITICIAN' && (
					<Badge
						data-testid="politician-badge"
						iconOnly
						leadingIcon={<DecisionMakerIcon size="x-large" />}
						size="large"
						variant="information"
						emphasis="weaker"
						className="absolute bottom-[-24px] z-10 flex size-14 justify-center rounded-full border-4 border-white"
					/>
				)}
			</div>
		</div>
	);
};
